import PropTypes from 'prop-types';
import React from 'react';
import { graphql } from 'gatsby';
import Layout from '../../organisms/Layout/Layout';

import BubbleCtaSection from '../../organisms/BubbleCtaSection/BubbleCtaSection';
import { renderPageSections } from '../renderPageSections';

const ClientPage = ({ data, location: { href } }) => {
  // unpublished pages return null data
  if (!data || data.sanityClientPage === null) {
    return null;
  }

  const clientPageProps = {
    id: data.sanityClientPage._id,
    metadata: { ...data.sanityClientPage._rawRoute, href },
    sections: data.sanityClientPage._rawSections,
    bubbleCtaSection: data.sanityClientPage._rawBubbleCtaSection,
  };
  // adding translatable text for sidebar inside of slantbanner
  clientPageProps.sections[0].sidebarText =
    data.sidebarText.edges[0].node.content;

  // add Product Category Entity to slant banner for fixed side bar
  clientPageProps.sections[0].productCategoryEntity =
    data.productCategoryEntity.edges;

  return (
    <Layout
      menuColor="white"
      sanityId={clientPageProps.id}
      {...clientPageProps.metadata}
    >
      {renderPageSections(clientPageProps.sections)}
      {clientPageProps.bubbleCtaSection && (
        <BubbleCtaSection {...clientPageProps.bubbleCtaSection} />
      )}
    </Layout>
  );
};

ClientPage.propTypes = {
  data: PropTypes.shape({
    sanityClientPage: {},
    sidebarText: {},
    productCategoryEntity: {},
  }),
  location: PropTypes.shape({ href: PropTypes.string }),
};

ClientPage.defaultProps = {
  data: {},
  location: { href: '' },
};

export default ClientPage;

export const query = graphql`
  query($slug: String) {
    sanityClientPage(
      route: { enabled: { eq: true }, slug: { current: { eq: $slug } } }
    ) {
      _id
      _rawRoute(resolveReferences: { maxDepth: 100 })
      _rawSections(resolveReferences: { maxDepth: 100 })
      _rawBubbleCtaSection(resolveReferences: { maxDepth: 100 })
    }
    sidebarText: allSanitySidebarText {
      edges {
        node {
          content
        }
      }
    }
    productCategoryEntity: allSanityProductCategoryEntity {
      edges {
        node {
          displayName
          shortDescription
          productOrdering
          linkWithoutTitle {
            link {
              ... on SanityRoute {
                id
                routeName
                slug {
                  current
                  _type
                }
              }
            }
          }
        }
      }
    }
  }
`;
